import { FilterProps } from "../filter-definition";
import { DateRangeFilter } from "../GenericFilters";

export const EndShipFilter = ({ variant }: FilterProps) => (
  <DateRangeFilter filterKey="endShip" name="End Ship" variant={variant} />
);
